(function () {
  var PREORDER_VARIANT_ID = document.querySelector('[data-preorder-variant]')
    ?.dataset.preorderVariant;

  if (!PREORDER_VARIANT_ID) return;

  function updateNote(variantId) {
    var note = document.querySelector('.preorder-note');
    if (!note) return;
    note.style.display = String(variantId) === String(PREORDER_VARIANT_ID) ? '' : 'none';
  }

  // Watch the hidden variant input for changes (Horizon updates this on variant select)
  var form = document.querySelector('form[action*="/cart/add"]');
  if (form) {
    form.addEventListener('change', function (e) {
      var input = form.querySelector('input[name="id"]');
      if (input) updateNote(input.value);
    });

    // Also watch via MutationObserver in case Horizon sets the value programmatically
    var input = form.querySelector('input[name="id"]');
    if (input) {
      new MutationObserver(function () {
        updateNote(input.value);
      }).observe(input, { attributes: true, attributeFilter: ['value'] });
    }
  }

  // Also catch Horizon's custom variant:change event if dispatched on document
  document.addEventListener('variant:change', function (e) {
    if (e.detail && e.detail.variant) updateNote(e.detail.variant.id);
  });
})();
